import React, { createContext, FC, useReducer } from "react";

export interface ICollapsibleStateContext {
  collapsibleState: {
    [id: string]: boolean;
  }
  setCollapsibleState: (id: string, isOpen: boolean) => void;
}

export const CollapsibleStateContext = createContext<ICollapsibleStateContext>({} as ICollapsibleStateContext);

export const CollapsibleStateContextProvider: FC = ({children}) => {
  const [collapsibleState, dispatch] = useReducer(reducer, {}, ()=> ({}));

  const setCollapsibleState = (id: string, isOpen: boolean) => {
    dispatch({id, isOpen});
  };
  const state = { collapsibleState, setCollapsibleState };

  return (
    <CollapsibleStateContext.Provider value={state}>
      {children}
    </CollapsibleStateContext.Provider>
  );
};

function reducer (state, action) {
  return {
    ...state,
    [action.id]: action.isOpen,
  };
};

